import React, {useEffect, useRef, useState} from 'react';
import { getBranchList } from '../../actions/commonAction';
import { handleEditOrderModal } from '../../reducers/uiSlice';
import {makeStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import EditOrderModal from '../../components/EditOrderModal';
import {
    setCrOptions,
    setRsOptions,
    toggleLoadingResendOrders,
    updateResendOrders,
} from '../../reducers/resendOrderSlice';
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';
import {useDispatch, useSelector} from 'react-redux';
import FullscreenLoading from '../../components/Common/FullscreenLoading';
import {
    loadResendOrders,
    loadCrOptions,
    loadRsOptions,
} from '../../actions/resendOrderActions';
import { useTranslation } from 'react-i18next';
import { getBranchById } from '../../utilities/common';

const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
        width: '100%'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    borderRight: {
        borderRightStyle: 'solid', 
        borderRightColor: "#424242"
    },
    headerFont: {
        fontSize: "1.2rem"
    },
    headerStyle: {
        borderRightStyle: 'solid', 
        borderRightColor: "#424242",
        fontSize: "1.2rem"
    },
    headerBackground: {
        backgroundColor: '#212121'
    },
    selectWidth: {
        width: 200
    }
}));

const moment = require('moment');

function createRow({old_order, new_order}) {
    const oldOrderData = pickOrderData(old_order, 'old');
    const newOrderData = pickOrderData(new_order, 'new');
    return {...oldOrderData, ...newOrderData};
}

function pickOrderData(order, prefix) {
    const {
        address1,
        city,
        consignee,
        state,
        province,
        tno,
        update_time,
        warehouse,
        storage_info
    } = order;
    return {
        [prefix + '_address']: address1,
        [prefix + '_city']: city,
        [prefix + '_reciever']: consignee,
        [prefix + '_status']: state,
        [prefix + '_province']: province,
        [prefix + '_orderID']: tno,
        [prefix + '_update_time']: moment(update_time * 1000).format(
            'MM-DD HH:mm'
        ),
        [prefix + '_warehouse']: warehouse,
        [prefix + '_storage_info']: storage_info
    };
}

export default function DenseTable(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {t} = useTranslation('resendOrders');

    const originalDataArray = useRef();

    const isLoading = useSelector((state) => state.resendOrder.isLoading);

    const rsOptions = useSelector((state) => state.resendOrder.rsOptions);
    const crOptions = useSelector((state) => state.resendOrder.crOptions);

    const dataArray = useSelector((state) => state.resendOrder.dataArray);
    const rows = dataArray.map((data, index) => {
        const row = createRow(data);
        return {id: index + 1, ...row};
    });

    const [rsValue, setRsValue] = useState('');
    const [crValue, setCrValue] = useState('');
    const [oWarehouseValue, setOWarehouseValue] = useState('');
    const [nWarehouseValue, setNWarehouseValue] = useState('');
    const [oStatusValue, setOStatusValue] = useState('');
    const [nStatusValue, setNStatusValue] = useState('');
    const [open, setOpen] = useState(false);
    const [tno, setTno] = useState('');
    const [branches, setBranches] = useState([]);

    const orderStatus = {
        190: "ORDER_RECEIVED",
        198: "CUSTOM_RELEASE_DIRECT",
        199: "GATEWAY_TRANSIT",
        200: "PARCEL_SCANNED",
        202: "IN_TRANSIT",
        203: "DELIVERED",
        204: "TRANSSHIPMENT",
        206: "WRONG_ADDRESS_FROM_TRANSIT",
        207: "PARCEL_LOST",
        209: "OTHER_EXCEPTION",
        211: "RETURN_OFFICE_FROM_TRANSIT",
        212: "WRONG_ADDRESS_FROM_RECEIVE",
        213: "STORAGE_30_DAYS_FROM_OFFICE",
        215: "PARCEL_ABANDONED",
        216: "SELF_PICK_UP",
        217: "TRANSSHIPMENT_COMPLETE",
        218: "SCANNED_PARCEL_MISSING",
        219: "WRONG_ROUTE_PARCEL",
        220: "SECOND_DELIVERY",
        221: "RETURNED_PARCEL_SCANNED",
        222: "REJECTED_PARCEL_FROM_TRANSIT",
        223: "CHANGED_ORDER_RESENT",
        224: "RESENT_ORDER_VOIDED",
        225: "FORWARDED_3RDPARTY",
        230: "RETURN_TO_SENDER_WAREHOUSE",
        255: "MAIN_PORT_GATEWAY_TRANSIT"
    }

    useEffect(() => {
        if (originalDataArray.current) {
            const filteredDataArray = originalDataArray.current.filter(
                (row) => {
                    const oWarehouseFilter = !!oWarehouseValue
                        ? row.old_order.warehouse === oWarehouseValue
                        : true;
                    const oStatusFilter = !!oStatusValue
                        ? row.old_order.state === oStatusValue
                        : true;
                    const nWarehouseFilter = !!nWarehouseValue
                        ? row.new_order.warehouse === nWarehouseValue
                        : true;
                    const nStatusFilter = !!nStatusValue
                        ? row.new_order.state === nStatusValue
                        : true;

                    return (
                        oWarehouseFilter &&
                        oStatusFilter &&
                        nWarehouseFilter &&
                        nStatusFilter
                    );
                }
            );
            dispatch(updateResendOrders(filteredDataArray));
        }
    }, [
        oWarehouseValue,
        oStatusValue,
        dispatch,
        nWarehouseValue,
        nStatusValue,
    ]);

    useEffect(() => {
        const handleLoadRsOptions = () => {
            dispatch(loadRsOptions()).then((options) => {
                dispatch(setRsOptions(options));
                if (isNotEmptyArray(options)) {
                    dispatch(loadCrOptions(options));
                }
            });
        };

        handleLoadRsOptions();
    }, [dispatch]);

    useEffect(() => {
        setRsValue(rsOptions[0]);
    }, [rsOptions]);

    useEffect(() => {
        setCrValue(crOptions[0]);
    }, [crOptions]);

    useEffect(() => {
        const handleLoadCrOptions = (rs) => {
            dispatch(loadCrOptions(rs)).then((options) => {
                dispatch(setCrOptions(options));
            });
        };
        handleLoadCrOptions(rsValue);
    }, [dispatch, rsValue]);

    useEffect(() => {
        dispatch(getBranchList()).then((branches)=>{
            setBranches(branches);
        })
    }, [])

    const handleFetchData = (cr, rs, originalDataArray) => {
        dispatch(toggleLoadingResendOrders());
        dispatch(loadResendOrders(cr, rs)).then((orders) => {
            dispatch(toggleLoadingResendOrders());
            dispatch(updateResendOrders(orders));
            originalDataArray.current = orders;
        });
    };

    const isNotEmptyArray = (obj) => {
        return Array.prototype.isPrototypeOf(obj) && obj.length > 0;
    };

    function editOrder(orderId) {
        dispatch(handleEditOrderModal({open: true}));
        setTno(orderId);
    }

    function handleClose() {
        setOpen(false);
    }

    return (
        <Box>
            <EditOrderModal 
                open={open} 
                tno={tno} 
                onClose={handleClose} 
                handleClose={handleClose} 
                byResendOrder={true} 
            />
            <Grid container spacing={3}>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <Select
                                id="RS-select"
                                value={rsValue}
                                onChange={(e) => setRsValue(e.target.value)}
                                className={classes.selectWidth}
                            >
                                {console.log(
                                    'rs value in select component',
                                    rsValue
                                )}
                                {rsOptions.map((option) => {
                                    return (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <Select
                                className={classes.selectWidth}
                                id="CR-select"
                                value={crValue}
                                onChange={(e) => setCrValue(e.target.value)}>
                                {crOptions.map((option) => {
                                    return (
                                        <MenuItem key={option} value={option}>
                                            {option}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <Button
                                className={classes.selectWidth}
                                variant="contained"
                                color="primary"
                                onClick={() =>
                                    handleFetchData(
                                        crValue,
                                        rsValue,
                                        originalDataArray
                                    )
                                }>
                                {t('fetch_data')}
                            </Button>
                        </FormControl>
                    </Grid>                   
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink id="o-warehouse-label">
                                {t('old_warehouse')}
                            </InputLabel>
                            <Select
                                labelId="o-warehouse-label"
                                id="o-warehouse"
                                value={oWarehouseValue}
                                onChange={(e) => setOWarehouseValue(e.target.value)}
                                displayEmpty
                                className={classes.selectWidth}
                            >
                                <MenuItem value="">
                                    <em>{t('all')}</em>
                                </MenuItem>
                                {
                                    (props.branches).map((branch, index) => {
                                        return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink id="o-status-label">
                                {t('old_status')}
                            </InputLabel>
                            <Select
                                labelId="o-status-label"
                                id="o-status"
                                value={oStatusValue}
                                onChange={(e) => setOStatusValue(e.target.value)}
                                displayEmpty
                                className={classes.selectWidth}
                            >
                                <MenuItem value="">
                                    <em>{t('all')}</em>
                                </MenuItem>
                                <MenuItem value={223}>{t('change_resend')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink id="n-warehouse-label">
                                {t('new_warehouse')}
                            </InputLabel>
                            <Select
                                labelId="n-warehouse-label"
                                id="n-warehouse"
                                value={nWarehouseValue}
                                onChange={(e) => setNWarehouseValue(e.target.value)}
                                displayEmpty
                                className={classes.selectWidth}
                            >
                                <MenuItem value="">
                                    <em>{t('all')}</em>
                                </MenuItem>
                                {
                                    (props.branches).map((branch, index) => {
                                        return <MenuItem key={index} value={branch.id}>{branch.name}</MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>                   
                </Grid>
                <Grid item container xs={2} align="center" justify="center"  direction="column">
                    <Grid item>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink id="n-status-label">
                                {t('new_status')}
                            </InputLabel>
                            <Select
                                labelId="n-status-label"
                                id="n-status"
                                value={nStatusValue}
                                onChange={(e) => setNStatusValue(e.target.value)}
                                displayEmpty
                                className={classes.selectWidth}
                            >
                                <MenuItem value="">
                                    <em>{t('all')}</em>
                                </MenuItem>
                                <MenuItem value={203}>{t('change_resend')}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>                    
                </Grid>
            </Grid>

            <TableContainer component={Paper} style={{marginTop: "20px"}}>
                <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table">
                    <TableHead className={classes.headerBackground}>
                        <TableRow>
                            <TableCell className={classes.borderRight}></TableCell>
                            <TableCell
                                colSpan={9}
                                align="center"
                                className={
                                    classes.headerStyle
                                }
                            >
                                {t('old')}
                            </TableCell>
                            <TableCell 
                                colSpan={9} 
                                align="center"
                                className={
                                    classes.headerFont
                                }
                            >
                                {t('new')}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center" className={classes.headerStyle}>#</TableCell>
                            <TableCell align="center">{t('address')}</TableCell>
                            <TableCell align="center">{t('city')}</TableCell>
                            <TableCell align="center">{t('receiver')}</TableCell>
                            <TableCell align="center">{t('status')}</TableCell>
                            <TableCell align="center">{t('province')}</TableCell>
                            <TableCell align="center"> {t('order_id')}</TableCell>
                            <TableCell align="center">{t('update_time')}</TableCell>
                            <TableCell
                                align="center"
                            >
                                {t('warehouse')}
                            </TableCell>
                            <TableCell 
                                align="center"
                                className={classes.borderRight}
                            >
                                {t('storage_info')}
                            </TableCell>
                            <TableCell align="center">{t('address')}</TableCell>
                            <TableCell align="center">{t('city')}</TableCell>
                            <TableCell align="center">{t('receiver')}</TableCell>
                            <TableCell align="center">{t('status')}</TableCell>
                            <TableCell align="center">{t('province')}</TableCell>
                            <TableCell align="center">{t('order_id')}</TableCell>
                            <TableCell align="center">{t('update_time')}</TableCell>
                            <TableCell align="center">{t('warehouse')}</TableCell>
                            <TableCell align="center">{t('storage_info')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, indexAll) => (
                            <TableRow 
                                key={row.id}
                                style={ indexAll % 2? { background : "#424242" }:{ background : "#303030" } }
                            >
                                {Object.keys(row).map((key, index) => {
                                    let branch = getBranchById(row[key]);
                                    if (index === 0 || index === 8) {
                                        if(key === 'old_warehouse' && branch) {
                                            return (
                                                <TableCell align="center">
                                                    {branch.short_name}
                                                </TableCell>
                                            );
                                        }
                                        return (
                                            <TableCell
                                                align="center"
                                                className={
                                                    classes.borderRight
                                                }>
                                                {row[key]}
                                            </TableCell>
                                        );
                                    } else {   
                                        if(key === 'old_status' || key === 'new_status') {
                                            return (
                                                <TableCell align="center">
                                                    {t('orderStatus:' + orderStatus[row[key]])}
                                                </TableCell>
                                            );
                                        } else if(key === 'old_orderID' || key === 'new_orderID') {
                                            return (
                                                <TableCell align="center" onClick={() => editOrder(row[key])} style={{ cursor: 'pointer' }}>
                                                    {row[key]}
                                                </TableCell>
                                            )
                                        } else if((key === 'new_warehouse' || key === 'old_warehouse') && branch) {
                                            return (
                                                <TableCell align="center">
                                                    {branch.short_name}
                                                </TableCell>
                                            );
                                        } else {
                                            return (
                                                <TableCell align="center">
                                                    {row[key]}
                                                </TableCell>
                                            );  
                                        }      
                                    }
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <FullscreenLoading open={isLoading} />
        </Box>
    );
}
